(function (angular) {
    'use strict';

    angular.module('rcs')
        /**
         *
         */
        .controller('rcsTestersController', 
        ['$scope', '$uibModalInstance', 'profilesService', '$stateParams', 'rcsServices', 'growlService', 'rcsConfig', 'sweetAlertService', 'testersProfiles',
            function ($scope, $uibModalInstance, profilesService, $stateParams, rcsServices, growlService, rcsConfig, sweetAlertService, testersProfiles) {

                var apiSpaceId =  $stateParams.pickedApiSpaceId;
                $scope.rcs = rcsConfig;
                var agentId = rcsConfig.agentId;
                $scope.returnedTestersId = [];
                $scope.testersProfiles = testersProfiles.filter((el) => { return el != undefined });
                
                $scope.removeTester = function(tester){
                    sweetAlertService.confirmationAlert(
                        "Are you sure?",
                        "Are you sure you want to remove" + tester.id + "?",
                        "Remove",
                        "Cancel",
                        function (isConfirmed) {
                            if (isConfirmed) {
                                rcsServices.removeTestUser(apiSpaceId, agentId, tester.id)
                                .then(function(result){
                                    var index = $scope.testersProfiles.indexOf(tester);
                                    $scope.testersProfiles.splice(index, 1);
                                    growlService.success("Tester deleted");
                                }).catch(function(error){
                                    growlService.danger("Tester wasn't deleted due to: " + error.statusText);
                                });
                            }
                        }
                    );
                    
                }

                $scope.refresh = (tester) => {
                    rcsServices.capabilityCheck(apiSpaceId, agentId, tester.phoneNumber).then((result) => {
                        var patch = {
                            rcs: {
                                agents: {

                                },
                                capabilities: result
                            }
                        }
                        var updated;
                        if(!tester.rcs.capabilities && result){
                            patch.rcs.agents[agentId] = "active";
                            updated = true;
                        } else if (tester.rcs.capabilities && !result) {
                            updated = true;
                            patch.rcs.agents[agentId] = "inactive";
                        } else if (!tester.rcs.capabilities && !result) {
                            updated = false;
                        } else if (tester.rcs.capabilities.length !== result.length || tester.rcs.capabilities.sort().join('') !== result.sort().join('')){
                            updated = true;
                            if(result.length && tester.rcs.agents[agentId] !== "active"){
                                patch.rcs.agents[agentId] = "active";
                            }
                        } else if(result.length && tester.rcs.capabilities.length === result.length && tester.rcs.capabilities.sort().join('') === result.sort().join('') && tester.rcs.agents[agentId] !== "active"){
                            updated = true;
                            delete patch.rcs.capabilities;
                            patch.rcs.agents[agentId] = "active";
                        }
                        
                        if(updated){
                            profilesService.patchProfile(apiSpaceId, tester.id, patch).then((patchResult) => {
                                $scope.testersProfiles[$scope.testersProfiles.indexOf(tester)] = patchResult;
                                tester = patchResult;
                                growlService.success("New capabilities successfully applied to tester profile.");
                            }).catch(function(error){
                                growlService.danger("Tester wasn't patched due to: " + error.statusText);
                            })
                        } else {
                            growlService.success("No changes in tester.");
                        }
                    }).catch(function(error){
                        if(tester.rcs.agents[agentId] === 'active' ){
                            rcsServices.removeTestUser(apiSpaceId, agentId, tester.id)
                                .then(function(result){
                                    var index = $scope.testersProfiles.indexOf(tester);
                                    $scope.testersProfiles.splice(index, 1);
                                    growlService.success("Profile was deleted due to: it's not a tester anymore");
                                }).catch(function(error){
                                    growlService.danger("Tester wasn't deleted due to: " + error.statusText);
                                });
                        }
                        else{
                            growlService.danger("Couldn't perform capability checkdue to: " + error.statusText);
                        }
                    })
                }

                $scope.phoneNumberCheck = function (value){
                    return /^\+?[1-9]\d{1,14}$/.test(value);
                }

                $scope.inviteTestUser = function(phoneNumber){

                    if (phoneNumber && phoneNumber.charAt(0) == '+') {
                        phoneNumber = phoneNumber.substr(1);
                    }

                    rcsServices.inviteTestUser(apiSpaceId, agentId, phoneNumber)
                        .then(function(result){
                            growlService.success("You've invited a new tester");
                            profilesService.getProfileDirect(apiSpaceId, result.profileId)
                            .then(function(result){
                                $scope.testersProfiles.push(result);
                            })
                            .catch(function(error){
                                growlService.danger("New tester wasn't invited correctly due to: " + error.statusText);
                            });
                        }).catch(function(error){
                            growlService.danger("New tester wasn't invited correctly due to: " + error.statusText);
                            if(error.status == 400){
                                $scope.errorMessage = "This doesn't look like a valid phone number with country code, please try again."
                            }
                            else if(error.status == 404){
                                $scope.errorMessage = "This phone number doesn't have RCS configured."
                            }
                        });
                }

                $scope.cancel = function(){
                    $uibModalInstance.close($scope.saveChanges());
                };
                
                $scope.close = function(){
                    $uibModalInstance.close($scope.saveChanges());
                };

                $scope.showCapabilities = (capabilities) => {
                    var objectToDisplay = ""
                    for(var capability of capabilities){
                        objectToDisplay += "<div><span class='break-word'>" + capability + "</span></div>";
                    }
                    return objectToDisplay;
                }

                $scope.saveChanges = function(){
                    for( var tester of $scope.testersProfiles){
                        $scope.returnedTestersId.push(tester.id);
                    }
                    return $scope.returnedTestersId;
                }
        }]);


})(window.angular);